import React, { useState, useEffect } from 'react';
import { capitalizeFirst, errorMsg, homeUrl, rearrangeArray, success } from '../utils/common_utils';
import IndefiniteProgressBar from "../ui_components/indefinite_progress_bar";
import {  getUIState, getUser, isPremiumUser, refreshHomePageDetails } from '../login/auth_utils';
import { LockIcon, SearchIcon, UnlockIcon } from '../ui_components/common_icons';
import { AIInterviewerLinkHomePage, DSAPageLinkHomePage, PreparationLinkHomePage } from '../preparation_plans/preparation_home_page_link';
import { DoNotLikeCodeZymFormButton } from '../customer_support/do_not_like_codezym';
import { MockInterviewTopmateHomePage } from './mock_interview';
import { LinkUI, LinkUIBasic, LinkUIBlueBold } from '../ui_components/common_links';
import { CodeZymPremiumWithMock } from '../premium/premium_with_mock_interview';
import { BRR, ExpandCloseTab, SPACE, SPACE2 } from '../ui_components/common_ui_components'
import { BulkSubscriptionOneLine } from '../premium/bulk_subscription';
import { CompanyMetadataListSingleRowUI, QuestionDifficultyTagUI, TagsListUI } from './tags_list_ui';
import { addCompanyUrlsInPlace, orderCompaniesByQuery } from './question_utils';
import { ConnectAndBook } from '../ui_components/connect_and_book';
import PosthogService from '../tracking_posthog/posthog_tracking';
import { PostHog } from 'posthog-js';
import HomeActionCards from './home_page_top_row_cards';
import { DesktopQuestionsTable, MobileQuestionsList } from './question_row_ui';
import { FooterSection } from '../ui_components/footer';
import { GenericPremiumOneLineComponent } from '../premium/home_page_discount_ui';


function AllQuestionsTable() {
  const [questionList, setQuestionList] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('')
  const isPremium = isPremiumUser();
  const uiState = getUIState()

  console.log("going to build all questions table : ")

  // this query will be used to filter questions list
  const [query, setQuery] = useState("")

  /** this is list of companies that will be shown just  below search bar */
  const [companyMetadataList, setCompanyMetadataList] = useState([])

  const updateSearchQuery = (query) => {
    setQuery(query)
    PosthogService.capture("main_page_search_query", {
      search_text: query || '',
      email: getUser()?.email || "not-logged-in"
    })
  }

  /** returns true then we display question else we don't */
  const showQuestion = (q, question) => {
    const qq = (q ?? "").trim().toLowerCase();
    if (!qq) return true;

    const heading = "" + question.questionId + ". " + (question.heading ?? "") +
      " " + (question.designPatterns ?? "")

    const inHeading = heading.toLowerCase().includes(qq);

    const inCompanies = (question.companies ?? []).some(
      (c) =>
        (c?.name ?? "").toLowerCase().includes(qq) ||
        (c?.code ?? "").toLowerCase().includes(qq)
    );

    return inHeading || inCompanies;
  };

  /** fetches companies metadata like name, code, search text etc */
  function fetchCompanyMetadataList() {
    console.log("fetching all companies metadata list");
    fetch(homeUrl() + "companiesApi/companiesMetadataList", {
      method: "GET"
    })
      .then((response) => response.json())
      .then((data) => {
        if (success(data.status)) {
          setCompanyMetadataList(data.list)
        }
        console.log("companies metadta list response received " + data.list.length + " companies ")
        console.log(data);
      })
      .catch((error) => {
        console.log("error occurred in fetching all company metadata list " + JSON.stringify(error));
        setError(errorMsg())
      });
  }

  /** fetches list of all questions */
  function fetchAllQuestionsList() {
    console.log("fetching the all questions list");
    fetch(homeUrl() + "questionsApi/allQuestions", {
      method: "GET"
    })
      .then((response) => response.json())
      .then((data) => {
        if (success(data.status)) {
          addCompanyUrlsInPlace(data.questions)
          setQuestionList(data.questions)
        }
        else {
          setError(data.message || "Error in fetching questions, please try again")
        }

        console.log("response received " + data.questions.length + " questions")
        console.log(data);
        refreshHomePageDetails()
      })
      .catch((error) => {
        console.log("error occurred in fetching all questions " + JSON.stringify(error));
        setError(errorMsg())
      });
  }

  useEffect(() => {
    fetchAllQuestionsList()
    fetchCompanyMetadataList()
  }, []);

  const filteredQuestions = questionList.filter((row) => showQuestion(query, row));

  return (
    <div className="flex flex-col overflow-x-hidden 
      w-full items-center justify-center">
      {false && <DoNotLikeCodeZymFormButton />}

      <div className="mb-0 md:mb-4">
        <GenericPremiumOneLineComponent />
      </div>

      {
        <div className="px-4 text-center text-slate-800">
          <div
            className=" mx-auto max-w-4xl py-4 md:py-8
              text-3xl md:text-5xl font-extrabold
              leading-snug md:leading-tight tracking-tight"
          >
            Practice Top{" "}
            <span className="bg-gradient-to-r from-orange-600
             to-red-500 bg-clip-text text-transparent">
              Low Level Design, 
            </span>
            <br className="hidden sm:block" />
            <span className="sm:hidden"> </span>
            <span className="bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              DS & Algo Round
            </span>{" "}
            Interview Questions
          </div>
        </div>
      }

      <div className="flex flex-row-responsive items-center justify-center md:space-x-8">
        <HomeActionCards />

        {false && <AIInterviewerLinkHomePage />}

        {false && <PreparationLinkHomePage />}
      </div>

      <br />

      {false && !isPremium &&
        <div className="text-center items-center justify-center">
          <CodeZymPremiumWithMock />
        </div>
      }

      <br />

      <div className="relative flex w-full max-w-4xl items-center px-3 md:px-0">
        <span className="pointer-events-none absolute left-7 md:left-4 text-gray-400">
          <SearchIcon />
        </span>

        <input
          type="text"
          value={query}
          onChange={(e) => updateSearchQuery(e.target.value)}
          placeholder="Search by question number, title or company e.g. amazon"
          aria-label="Search by heading or company"
          className="w-full rounded-xl border border-gray-300 bg-white py-2 pl-12 
          pr-4 text-sm shadow-sm placeholder:text-gray-400
          focus:border-indigo-500 focus:outline-none"
        />
      </div>

      <br />

      <CompanyMetadataListSingleRowUI
        companies={companyMetadataList}
        query={query}
        count={4}
      />

      <br />

      {questionList.length > 0 &&
        <>
          <MobileQuestionsList
            questions={filteredQuestions}
            query={query}
            isPremium={isPremium}
          />

          <DesktopQuestionsTable
            questions={filteredQuestions}
            query={query}
            isPremium={isPremium}
          />
        </>
      }

      {!error && !message && questionList.length == 0 &&
        <div className="text-2xl font-bold text-blue-700">
          Loading all Questions. <br /> Please wait ...
        </div>
      }

      {!error && questionList.length == 0 &&
        <div className="mt-32 z-50">
          <IndefiniteProgressBar />
        </div>
      }

      {error && error.length > 0 &&
        <div className="text-lg font-semibold text-red-700">
          {error} <br />
        </div>
      }

      {message && message.length > 0 && !error && error.length == 0 &&
        <div className="text-xl font-bold text-blue-700">
          {message} <br />
        </div>
      }

      <br />

      <ConnectAndBook />
      <FooterSection />
     

    </div>
  );
}



export default AllQuestionsTable